import { useEffect } from 'react';
import { Spin } from 'antd';
import { useAuth } from '../../context/AuthContext';

function Logout() {
  const { logout, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      logout();
    }
  }, [isAuthenticated, logout]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spin size="large" tip="Logging out..." />
    </div>
  );
}

export default Logout;